import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { callQueueSelector } from '@rsos/reduxDataStore/src/features/selectors/callQueueSelector';
import checkAniAliAccessSelector from '@rsos/utils/checkAniAliAccessSelector';
import isAgencyShareChatEnabled from '@rsos/utils/isAgencyShareChatEnabled';
import ASCDropdown from './ASCDropdown';

export const AgencyShareChatButton = () => {
  const { psaps } = useSelector(state => state);

  const hasAniAliAccess = useSelector(state =>
    checkAniAliAccessSelector({ psaps: state.psaps, sinatra: state.sinatra }),
  );
  const filteredCalls = useSelector(state =>
    callQueueSelector(state.emergencyCalls.callQueue, hasAniAliAccess),
  );

  const selectedCallerID = useSelector(
    state => state.emergencyCalls.selectedCallerID,
  );

  const selectedCall = filteredCalls?.[selectedCallerID];

  const isCallExpired = !!selectedCall?.isCallExpired;

  const isCallReceived = !!selectedCall?.agencyShareChat?.isCallReceived;

  const agencyLinksTo = useSelector(
    state => state.peerAgencies.agencyLinks.linksTo,
  );

  const peerAgencies =
    agencyLinksTo &&
    agencyLinksTo.length &&
    agencyLinksTo.filter(agency => agency.status === 'active');

  // Agency share/chat dropdown is rendered if the authority has the capability enabled, the 911
  // event is not expired, the 911 event is not a received event by another authority, and there are
  // paired peer agencies.
  const shouldRenderDropdown = useMemo(() => {
    return !!(
      isAgencyShareChatEnabled(psaps) &&
      !isCallExpired &&
      !isCallReceived &&
      peerAgencies.length
    );
  }, [peerAgencies, isCallExpired, isCallReceived, psaps]);

  return shouldRenderDropdown ? (
    <ASCDropdown peerAgencies={peerAgencies} />
  ) : null;
};

export default AgencyShareChatButton;
